module.exports = __webpack_public_path__ + "static/media/error.a43ee6d3.jpg";